export const getDimensions = () => {
    const height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    return {
        width,
        height,
    };
};
//# sourceMappingURL=dimensions.js.map